import { render, staticRenderFns } from "./legal-documen-template-filter.vue?vue&type=template&id=2b86a580"
import script from "./legal-documen-template-filter.vue?vue&type=script&lang=js"
export * from "./legal-documen-template-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports